import type {State} from '../reducers/types'
import {getExtensionEndpoint} from '../selectors'
import type {UrlExtension} from '../types'

export const getStatisticsExtension = (state: State): UrlExtension<any> | null | undefined =>
  getExtensionEndpoint(state, 'fus-analytics')

export const generateBatchPayload = (eventsQueue: any[]) => ({
  events: eventsQueue,
  batchTime: Date.now(),
})
